import { FC, useEffect, useRef } from "react";
import { useBloc as useBlocNext } from "@blac/react";
import AuthenticationBloc from "src/state/UserCubit/AuthenticationBloc";
import UserCubit from "src/state/UserCubit/UserCubit";
import UserPreferencesCubit from "src/state/UserPreferencesCubit/UserPreferencesCubit";
import { useBloc, userState } from "src/state/state";
import {
  AppPopup,
  AppQueryPopupsController
} from "../AppQueryPopups/AppQueryPopupsBloc";
import reportErrorSentry from "src/lib/reportErrorSentry";
import { FUNNEL_QUESTIONNAIRE_ELIGIBILITY } from "src/constants/misc";
import { isAnyPartnerAcceptedAuthMethod } from "src/constants/partnerConfig";

const SessionConfirmationCheck: FC = () => {
  const hasPerformedCheck = useRef(false);

  const [{ authenticationStatus }] = useBlocNext(AuthenticationBloc);
  const [{ userData }] = useBloc(UserCubit);
  const [, { loadUserPreferences, firstName, lastName }] =
    useBlocNext(UserPreferencesCubit);

  useEffect(() => {
    if (hasPerformedCheck.current) {
      return;
    }

    const checkSessionConfirmation = async () => {
      try {
        // Load user preferences to ensure we have the latest data
        await loadUserPreferences();
        const hasAnsweredGenericEligibility =
          await userState.checkUserHasAnsweredQuestionnaire(
            FUNNEL_QUESTIONNAIRE_ELIGIBILITY
          );

        if (!userData) {
          return;
        }

        hasPerformedCheck.current = true;

        if (!hasAnsweredGenericEligibility) {
          return;
        }

        if (
          isAnyPartnerAcceptedAuthMethod(userData.sessionAuthenticationMethod)
        ) {
          return;
        }

        if (firstName && lastName) {
          AppQueryPopupsController.openPopup(AppPopup.sessionConfirmation, {
            additionalParameters: {
              stay: "false"
            }
          });
        }
      } catch (error) {
        reportErrorSentry(error);
        return;
      }
    };

    void checkSessionConfirmation();
  }, [authenticationStatus, userData, firstName, lastName, hasPerformedCheck]);

  return null;
};

export default SessionConfirmationCheck;
